import PubSub, { AppDispatcher } from 'services/PubSub/';
import { actionsType, ecommerce } from 'config/constants';
import ProductService from 'services/Product/';
import ListService from 'services/AccountLists/';
import ProductFactory from 'factories/Products';
import SearchService from 'services/Search'
import queryString from 'query-string';
import SalesChannel from 'services/SalesChannel'
import { slugify } from 'utils/index'
import CatalogService from 'services/Catalog';

const productsFactory = (products, promotions) => {
    if (!(products && products[0])) return [];
    return products.map(product => {
        return ProductFactory.setPromotions(ProductFactory.create(product), promotions);
    });
};

const productFactory = (product, promotions) => {
    if (!(product && product[0])) return [];
    return ProductFactory.setPromotions(ProductFactory.create(product[0]), promotions);
};

const promotionsAndOrder = (products, promotions, other = true) => {
    let productsNoStock = [];
    products = products.map(product => {
        const _prod = ProductFactory.setPromotions(ProductFactory.create(product), promotions);

        if(other && _prod.items && !ProductFactory.hasStock(_prod.items[0])){
            productsNoStock.push(_prod);
            return false;
        }
        return _prod;
    }).filter(Boolean);
    products = products.concat(productsNoStock);
    return products;
}
const getSearchBrands = (brands) => {
    return brands.split(',').map(item => {
        return { "key": "marca", "value": item }

    });
}

const getSearchFilters = (filters) => {
    return filters.split(',').map(item => {
        const data = item.split(':');
        return { "key": slugify(data[0]), "value": data[1] }
    });
}

const actions = {
    getProductsCollection(id, campaign = null, filter = null) {
        const promises = [ProductService.getPromotions()]
        
        if(campaign && !ecommerce.JumboTest){
            promises.push(ProductService.getRankedCollection(id, campaign, filter))
        }else{
            promises.push(ProductService.getByURl(`/busca?fq=${id}`))
        }

        return Promise.all(promises)
            .then(results => {
                const promotions = results[0];
                const productsData = results[1];

                let _products = (!campaign || ecommerce.JumboTest) && productsData ? productsData.products : productsData;
                //let productsNoStock = [];
                let products = _products ?
                    promotionsAndOrder(_products, promotions, campaign)
                    : [];
                //products = products.concat(productsNoStock);

                AppDispatcher.dispatch({
                    type: actionsType.GET_PRODUCTS,
                    payload: { id, products }
                });

                return products;
            });
    },
    getRecommended(numberResults = false, sku = false, campaingName = false, filter = false, type = false, categoryId = false, filterValues = null) {
        if (!campaingName) return Promise.resolve([])
        return Promise.all([
            ProductService.getPromotions(),
            CatalogService.getRecommended(numberResults, sku, campaingName, filter, type, categoryId, filterValues)
        ]).then(results => {

            const promotions = results[0];
            const productsData = results[1];
            const products = productsData && productsData.length ? 
                promotionsAndOrder(productsData, promotions) : [];
            let idDispatch = '';
            if(sku && campaingName && filter) idDispatch = filter;

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCTS,
                payload: {
                    id: idDispatch ? idDispatch : 'products-recommended',
                    products
                }
            });

            return products;
        })
    },
    getProductsBySkus(skus, school = false) {
        return Promise.all([
            ProductService.getPromotions(),
            ListService.productsSkus(skus)
        ]).then(results => {
            const promotions = results[0];
            const productsData = results[1];

            const products = productsData ? productsData.map(product => {
                return ProductFactory.setPromotions(ProductFactory.create(product), promotions);
            }) : [];

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCTS_SKU,
                payload: {
                    id: JSON.stringify(skus),
                    products
                }
            });
            if(school){
                setTimeout(()=> PubSub.dispatch('GET_PRODUCTS_SCHOOL', products), 0);
            }
            return results;
        });
    },

    searchProducts(search) {
        return Promise.all([
            ProductService.getSearchProducts(search),
            ProductService.getPromotions()
        ]).then(results => {
            if(!results) return [];
            const products = productsFactory(results[0], results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_SEARCH_PRODUCTS,
                payload: {
                    id: 'search',
                    products
                }
            });

            return products;
        });
    },
    getSearchProducts(search, _page, query, pathParams, notStore = false){
        const params = queryString.parse(query);
        const page = _page || 1;

        let body = {
            selectedFacets: [
                { "key": "trade-policy", "value": SalesChannel.getSalesChannel().toString() },
            ]
        };

        if(params.b){
            body.selectedFacets = body.selectedFacets.concat(getSearchBrands(params.b));
        }

        if(params.s){
            body.selectedFacets = body.selectedFacets.concat(getSearchFilters(params.s));
        }

        if(pathParams && pathParams.category1){
            if(pathParams.category3){
                body.selectedFacets.push({
                    key: 'category-3',
                    value: pathParams.category3
                });
            } else if(pathParams.category2){
                body.selectedFacets.push({
                    key: 'category-2',
                    value: pathParams.category2
                });
            } else {
                body.selectedFacets.push({
                    key: 'category-1',
                    value: pathParams.category1
                });
            }
        }

        if(params.o){
            body.orderBy = params.o;
        }

        return Promise.all([
            SearchService.getProducts(search, page, body),
            ProductService.getPromotions()
        ]).then(results => {
            const dataProducts = results[0];
            const products = productsFactory(dataProducts.products, results[1]);
            
            if(!notStore){
                AppDispatcher.dispatch({
                    type: actionsType.GET_SHELF_PRODUCTS,
                    payload: {
                        id: 'search',
                        products
                    }
                });
            }

            return {
                redirect: dataProducts.redirect,
                data: dataProducts.products,
                quantity: dataProducts.recordsFiltered,
                correction: dataProducts.correction,
                operator: dataProducts.operator
            };
        }).catch(() => {
            return {
                data: [],
                quantity: 0
            };
        })
    },
    getSearchFacets(search, params){
        return SearchService.getFacets(search, params);
    },
    getShelfProducts(url) {
        return Promise.all([
            ProductService.getByURl(url),
            ProductService.getPromotions()
        ]).then(results => {
            const products = productsFactory(results[0].products || results[0].data, results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_SHELF_PRODUCTS,
                payload: {
                    id: 'shelf',
                    products
                }
            });

            return results[0];
        });
    },
    getProduct(slug) {
        return Promise.all([
            ProductService.get(slug),
            ProductService.getPromotions()
        ]).then(results => {
            const product = productFactory(results[0], results[1]);

            AppDispatcher.dispatch({
                type: actionsType.GET_PRODUCT,
                payload: {
                    id: 'product',
                    products: [product]
                }
            });

            return product;
        });
    },
    getFrequentProducts(quantity) {
        return Promise.all([
            ProductService.getFrequentProducts(quantity),
            ProductService.getPromotions()
        ]).then(results => {
            if(results[0] && results[0].length > 1) {
                const products = productsFactory(results[0], results[1]);

                AppDispatcher.dispatch({
                    type: actionsType.GET_SHELF_PRODUCTS,
                    payload: {
                        id: 'frequent-products',
                        products
                    }
                });
            }

            return results[0];
        });
    }
};

export default actions;
